import { clamp } from './Clamp';
import { getOffset } from './Offsets';
function isNumber(n) {
    return n != null && Number.isFinite(n);
}
export function createReducer(iterator, initialValue) {
    return function (values, frameIndex, startOffsets, endOffsets) {
        const start = getOffset(startOffsets, frameIndex);
        const end = getOffset(endOffsets, frameIndex);
        const max = Object(values).length >>> 0;
        let from;
        let to;
        if (isNumber(start) && isNumber(end)) {
            from = clamp(frameIndex + start, 0, max);
            to = clamp(frameIndex + end + 1, from, max);
        }
        else {
            from = 0;
            to = max;
        }
        let memo = initialValue;
        let invocation = 0;
        if (typeof memo === 'undefined') {
            while (from < to && values[from] == null) {
                from += 1;
            }
            if (from === to) {
                return null;
            }
            invocation = 1;
            memo = values[from++];
        }
        while (from < to) {
            const value = values[from++];
            if (value != null) {
                memo = iterator(memo, value, invocation++);
            }
        }
        return memo;
    };
}
